module.exports = __webpack_public_path__ + "img/thumbnail_HimalayanBrownBear_m_normal.924e73c5.png";